(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-featured-ams"] && !window.DesignMode) return;
  try {
    
  $('.as-feature-inner-mob, .as-feature-inner').slick({
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metadvance-weight-meter"] && !window.DesignMode) return;
  try {
    
let accumulatedRotation = 360;
document.getElementById("weight-input").addEventListener("keydown", function(event) {
  if (event.key === '-' || event.key === 'e' || event.key === 'E') {
    event.preventDefault();  
  }
});
document.getElementById("weight-input").addEventListener("input", debounce(function () {
     this.value = this.value.replace(/[^0-9.]/g, '');
    if (this.value === '') {
        resetValues();
    return;
  }
 if (this.value > 150) {
    this.value = 150;
  } else if (this.value < 0) {
    this.value = 0;
  }
   const inputWeight = Math.min(parseFloat(this.value) || 0, 150);
  const output = document.getElementById("output");
  const needle = document.getElementById("needle");
  const valueDisplay = document.getElementById("input-value-display");
  const label = document.querySelector(".placeholder-label");

  if (this.value) {
    label.style.display = "none";
    valueDisplay.style.visibility = "visible";
  } else {
    label.style.display = "block";
    valueDisplay.style.visibility = "hidden";
  }

  const weightChange = inputWeight * 0.12;
  const rotationAngle = weightChange * 21; 
  const outwardDuration = 3000; 
  let newRotation = accumulatedRotation + rotationAngle;
  newRotation = Math.ceil(newRotation / 360) * 360;

  needle.style.transition = `transform ${outwardDuration}ms ease-in-out`;
  needle.style.transform = `rotate(${newRotation}deg)`;
  accumulatedRotation = newRotation;

  let currentValue = 0;
  const targetValue = Math.round(weightChange);
  const interval = Math.max(50, outwardDuration / Math.max(targetValue, 1)); 

  function countUp() {
    if (currentValue <= targetValue) {
      if (currentValue === 0) {
        output.textContent = `${currentValue} Kg`;
      }
      else {
        output.textContent = `-${currentValue} Kg`;
      }   
      const remainingWeight = inputWeight - currentValue;
      valueDisplay.textContent = `${Math.round(remainingWeight)} Kg`;
      currentValue++;
      setTimeout(countUp, interval);
    }
  }

  countUp();
}, 300));
  document.getElementById("weight-input").addEventListener("blur", function () {
  if (this.value === '') {
    resetValues();
  }
});

function resetValues() {
  const output = document.getElementById("output");
  const valueDisplay = document.getElementById("input-value-display");
  const label = document.querySelector(".placeholder-label");
  const needle = document.getElementById("needle");

  label.style.display = "block";
  valueDisplay.style.visibility = "hidden";
  output.textContent = '0 Kg';
  valueDisplay.textContent = '0 Kg';
  needle.style.transition = 'none';
  needle.style.transform = `rotate(${accumulatedRotation}deg)`;
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

  } catch(e) { console.error(e); }
})();
})();
